const originalFetch = window.fetch;

const getAuthToken = () => {
    const storedTokens = localStorage.getItem('auth_tokens');
    if (storedTokens) {
        try {
            const { access_token } = JSON.parse(storedTokens);
            return access_token;
        } catch (error) {
            console.error('Error parsing stored auth tokens:', error);
        }
    }
    return null;
};

const getRefreshToken = () => {
    const storedTokens = localStorage.getItem('auth_tokens');
    if (storedTokens) {
        try {
            const { refresh_token } = JSON.parse(storedTokens);
            return refresh_token;
        } catch (error) {
            console.error('Error parsing stored auth tokens:', error);
        }
    }
    return null;
};

const isApiUrl = (url) => {
    if (typeof url === 'string') {
        return url.startsWith('/api') || url.includes('/api/') || url.includes('/api?');
    }
    if (url instanceof URL || url instanceof Request) {
        const urlString = url instanceof Request ? url.url : url.href;
        return urlString.includes('/api/') || urlString.includes('/api?');
    }
    return false;
};

const isAuthEndpoint = (url) => {
    const urlString = typeof url === 'string' ? url : (url instanceof Request ? url.url : url.href);
    return urlString.includes('/api/auth/refresh') || urlString.includes('/api/auth/login') || urlString.includes('/api/auth/register');
};

const getApiBaseUrl = () => {
    if (process.env.NODE_ENV === "development") {
        return "/api";
    }
    
    const envUrl = window.REACT_APP_BACKEND_URL;
    
    if (!envUrl || envUrl === "") {
        return "/api";
    }
    
    if (envUrl.endsWith("/api")) {
        return envUrl;
    }
    
    return envUrl + "/api";
};

const refreshAccessToken = async () => {
    const refreshToken = getRefreshToken();
    if (!refreshToken) {
        return false;
    }
    
    try {
        const baseUrl = getApiBaseUrl();
        const response = await originalFetch(`${baseUrl}/auth/refresh`, {
            method: 'POST',
            headers: { 'Content-Type': 'application/json' },
            body: JSON.stringify({ refresh_token: refreshToken })
        });
        
        if (response.ok) {
            const data = await response.json();
            const storedTokens = JSON.parse(localStorage.getItem('auth_tokens') || '{}');
            storedTokens.access_token = data.access_token;
            localStorage.setItem('auth_tokens', JSON.stringify(storedTokens));
            window.dispatchEvent(new CustomEvent('auth:token-refreshed', { detail: { access_token: data.access_token } }));
            return true;
        }
    } catch (error) {
        console.error('Erro ao renovar token:', error);
    }
    
    return false;
};

const handleUnauthorized = () => {
    localStorage.removeItem('auth_tokens');
    window.dispatchEvent(new CustomEvent('auth:logout'));
    if (window.location.pathname !== '/login' && window.location.pathname !== '/register') {
        window.location.href = '/login';
    }
};

window.fetch = async function(url, options = {}) {
    let headers;
    
    if (options.headers instanceof Headers) {
        headers = options.headers;
    } else {
        headers = new Headers(options.headers || {});
    }
    
    if (isApiUrl(url)) {
        const token = getAuthToken();
        if (token && !headers.has('Authorization')) {
            headers.set('Authorization', `Bearer ${token}`);
        }
    }
    
    const newOptions = {
        ...options,
        headers: headers
    };
    
    let response = await originalFetch.call(this, url, newOptions);
    
    if (response.status === 401 && isApiUrl(url) && !isAuthEndpoint(url)) {
        const refreshed = await refreshAccessToken();
        
        if (refreshed) {
            const newToken = getAuthToken();
            if (newToken) {
                headers.set('Authorization', `Bearer ${newToken}`);
                const retryOptions = {
                    ...options,
                    headers: headers
                };
                response = await originalFetch.call(this, url, retryOptions);
                
                if (response.status === 401) {
                    handleUnauthorized();
                }
            } else {
                handleUnauthorized();
            }
        } else {
            handleUnauthorized();
        }
    }
    
    return response;
};

